import { IngredientRowViewModel } from "../../ingredientList/types/ingredientListView.types";

interface FootprintHeaderProps {
  ingredientDetails: IngredientRowViewModel | undefined;
}

/**
 * "Reference flow" header shown above the Environmental Footprint tab's
 * cards — the ingredient + its unit, and a basis pill on the right. Only a
 * single "Per kg ingredient" option exists today (a static pill, not a
 * `ToggleGroup`, since there's nothing to toggle to yet); a "Per unit"
 * segment can be added here later once that basis is supported.
 */
const FootprintHeader = ({ ingredientDetails }: FootprintHeaderProps) => {
  const details = ingredientDetails?.supplierIngredientDetails;

  return (
    <div className="tw-flex tw-items-end tw-justify-between tw-gap-4">
      <div>
        <p className="tw-mb-1 tw-text-[10px] tw-font-medium tw-uppercase tw-tracking-wider tw-text-muted-foreground">
          Reference flow
        </p>
        <p className="tw-text-sm tw-text-foreground ">
          {ingredientDetails?.ingredient_name || "-"} ·{" "}
          <span className="tw-font-mono">
            {details?.unit_size ?? "-"} {details?.unit_type ?? ""}
          </span>
        </p>
      </div>

      <div className="tw-inline-flex tw-shrink-0 tw-rounded-lg tw-border tw-border-border tw-bg-muted tw-p-0.5">
        <span className="tw-rounded tw-px-2.5 tw-py-1 tw-text-[11px] tw-font-semibold tw-text-foreground tw-shadow-sm tw-transition-colors tw-bg-background">
          Per kg ingredient
        </span>
      </div>
    </div>
  );
};

export default FootprintHeader;
